import { FieldErrorType, IFieldError, ICardFormFieldChange } from '../types';

export class CardFormValidationHelper {
  static validateFormField = (field: string, state: ICardFormFieldChange): IFieldError => {
    const friendlyName = CardFormValidationHelper.fieldName(field);
    if (state && state.empty) {
      return {
        type: FieldErrorType.IsRequired,
        message: `${friendlyName} is required.`,
      };
    } else if (state && !state.valid) {
      if (field === 'card' && state.length < 15) {
        return {
          type: FieldErrorType.IsMinLength,
          message: `${friendlyName} must be at least 15 digits.`,
        };
      }
      if (field === 'card' && state.length > 16) {
        return {
          type: FieldErrorType.IsMaxLength,
          message: `${friendlyName} must be less than 17 digits.`,
        };
      }
      return {
        type: FieldErrorType.IsNotValid,
        message: `${friendlyName} is not valid.`,
      };
    } else if (state) {
      if (field === 'postalCode' && state.length > 5) {
        return {
          type: FieldErrorType.IsMaxLength,
          message: `${friendlyName} must be 5 characters or less.`,
        };
      }
      if (field === 'name' && state.length > 25) {
        return {
          type: FieldErrorType.IsMaxLength,
          message: `${friendlyName} must be less than 26 characters.`,
        };
      }
      return {
        type: FieldErrorType.None,
      };
    } else {
      return {
        type: FieldErrorType.None,
      };
    }
  };

  static fieldName = (field: string): string => {
    switch (field) {
      case 'card':
        return 'Card number';
      case 'name':
        return 'Name';
      case 'exp':
        return 'Card expiration';
      case 'cvv':
        return 'CVV/security code';
      case 'postalCode':
        return 'ZIP code';
      default:
        return '';
    }
  };

  /**
   * Maps Adyen card brand names to our application's standard brand format.
   * Adyen uses different brand codes (e.g., 'mc' for Mastercard, 'amex' for American Express)
   * that need to be converted to our standard naming convention.
   *
   * @param adyenBrand - The brand name returned by Adyen (e.g., 'mc', 'visa', 'amex')
   * @returns The standardized brand name used in our application (e.g., 'mastercard', 'visa', 'americanexpress')
   */
  static mapAdyenBrandToStandard = (adyenBrand: string | undefined): string => {
    if (!adyenBrand) {
      return '';
    }

    const brand = adyenBrand.toLowerCase().trim();

    switch (brand) {
      case 'mc':
      case 'mastercard':
        return 'mastercard';
      case 'visa':
        return 'visa';
      case 'amex':
      case 'americanexpress':
      case 'american-express':
        return 'americanexpress';
      case 'discover':
      case 'dinersclub':
      case 'diners':
        return 'discover';
      case 'jcb':
        return 'jcb';
      case 'unionpay':
      case 'cup':
      case 'chinaunionpay':
        return 'unionpay';
      case 'maestro':
        return 'maestro';
      default:
        // Return the original brand if no mapping is found
        return brand;
    }
  };
}
